/* @flow */
import { Map } from 'immutable';
import { getQueryParams } from 'trustar/utils';

import { type OptionsShape, typeof User } from './types.js';
import {
  FETCH,
  FETCH_USER,
  SAVE,
  DELETE,
  DEACTIVATE,
  RESET_PASSWORD,
  EXPORT_ALL,
  SET_DISPLAY_OPTIONS,
  AUTOSUGGEST,
} from './action-types.js';

// Fetch all users
export const fetch = (payload: Object = getQueryParams()) => ({
  type: FETCH,
  payload,
});

// Fetch a specific user
export const fetchUser = (userId: string) => ({
  type: FETCH_USER,
  userId,
});

// Set display options; sorts and filters users for Admins
export const setDisplayOptions = (options: OptionsShape) => ({
  type: SET_DISPLAY_OPTIONS,
  payload: options,
});

export const search = (query: string) => setDisplayOptions({ query });

// Either create or update a user, depending on whether or not they have a guid.
export const saveUser = (user: Map<string, any> | User) => ({
  type: SAVE,
  payload: user,
});

export const deleteUser = (id: string) => ({
  type: DELETE,
  payload: id,
});

export const deactivateUser = (email: string, deactivated: boolean) => ({
  type: DEACTIVATE,
  payload: { email, deactivated },
});

// Send an email to user to reset their password or setup their account.
export const resetPassword = (user: Map<any, any>) => ({
  type: RESET_PASSWORD,
  payload: user,
});

/**
 * Export all users by downloading a csv file.
 * We use an iframe to avoid possibly redirecting the main browser to a faulty
 * endpoint that would case the user to lose anything they were in the middle
 * of.
 */
export const exportAll = () => ({
  type: EXPORT_ALL,
});

/**
 * Autosuggest users to mention based on the val string
 */
export const autosuggest = (val: string) => ({
  type: AUTOSUGGEST,
  payload: val,
});



// WEBPACK FOOTER //
// ./src/app/modules/users/actions.js